module.exports = require("@swa-ui/application/src/MessageProvider/ServiceErrorMessage.module.scss");